import { render, staticRenderFns } from "./TrialSettings.vue?vue&type=template&id=3ca44120&scoped=true"
import script from "./TrialSettings.vue?vue&type=script&lang=js"
export * from "./TrialSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca44120",
  null
  
)

export default component.exports